<template>
  <inertia-link :href="href" :class="classes">
    <slot></slot>
  </inertia-link>
</template>

<script>
export default {
  props: {
    href: {},
    active: {},
    scrollTo: {
      type: String,
      default: null
    },
  },

  computed: {
    classes() {
      return this.active
          ? 'inline-flex uppercase items-center px-1 py-3 lg:py-6 lg:border-b-2 lg:border-medium-blue text-sm font-medium leading-5 text-dark-blue lg:text-white focus:outline-none lg:focus:border-medium-blue transition duration-150 ease-in-out'
          : 'inline-flex uppercase items-center px-1 py-3 lg:py-6 lg:border-b-2 border-transparent text-sm font-medium leading-5 text-dark-blue lg:text-white lg:hover:border-white focus:outline-none focus:text-white focus:border-white transition duration-150 ease-in-out'
    }
  }
}
</script>
